import styled from 'styled-components';

export const Container = styled.header`
  display: flex;

  background: #ddd;
  border-bottom: 1px solid #eee;

  padding: 0 30px;
  height: 47px;
`;

export const ContainerMobile = styled.header`
  display: flex;

  background: #fff;
  border-bottom: 1px solid #eee;

  padding: 0 0 0 30px;
  height: 60px;
`;